import React, { useState, useEffect } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { change_password } from "../../../redux/authslice"


const Passwordpage = () => {

    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState({
        password: false,
        confirmPassword: false,
    });

    const [input, setInput] = useState({
        old_password: "",
        new_password: "",
        error: "",
    });

    const validatePasswords = () => {
        const { old_password, new_password } = input;

        // Check if passwords match
        // if (old_password !== new_password) {
        //     setInput({ ...input, error: "Passwords do not match." });
        //     return false;
        // }

        // Check password strength
        const strongRegex = new RegExp(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&()_+=|~?/-])(?!.*\\*).{8,}$"
        );

        if (!strongRegex.test(old_password)) {
            setInput({
                ...input,
                error:
                    "Password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, one digit, and one special character (excluding '*').",
            });
            return false;
        }

        setInput({ ...input, error: "" });
        return true;

    };

    const handleSubmit = () => {
        if (!validatePasswords()) {
            return
        } else {

            dispatch(change_password({ input, setInput, dispatch }));
        }
    };

    useEffect(() => {
        setInput({ ...input, error: "" });
    }, [input.old_password, input.new_password]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value });
    };

    const togglePasswordVisibility = (fieldName) => {
        setShowPassword({ ...showPassword, [fieldName]: !showPassword[fieldName] });
    };
    return (
        <>
            {/* -----------------Password Photo-------------------------- */}
            <section className="all-dasboard">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="profile-img-box">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <p className="pro-head">Password</p>
                                        <p className="pro-sub-head">
                                            Confirm your current password before updating
                                        </p>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="pofile-form-box">
                                            <form>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label
                                                                htmlFor="currentPassword"
                                                                className="input-box-head"
                                                            >
                                                                Current password
                                                            </label>
                                                            <div className="input-group mb-3">
                                                                <input
                                                                    type={showPassword.password ? "text" : "password"}
                                                                    className="form-control"
                                                                    id="currentPassword"
                                                                    name="old_password"
                                                                    value={input.old_password}
                                                                    onChange={handleInputChange}
                                                                    required=""
                                                                    placeholder="Enter current password"
                                                                />
                                                                <div className="bag-light-2" style={{ zIndex: 99999 }}>
                                                                    <FontAwesomeIcon
                                                                        icon={showPassword.password ? faEyeSlash : faEye}
                                                                        onClick={() => togglePasswordVisibility("password")}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label
                                                                htmlFor="newPassword"
                                                                className="input-box-head"
                                                            >
                                                                Enter new password
                                                            </label>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    id="newPassword"
                                                                    type={showPassword.confirmPassword ? "text" : "password"}
                                                                    name="new_password"
                                                                    placeholder="Enter new password"
                                                                    value={input.new_password}
                                                                    onChange={handleInputChange}
                                                                />
                                                                <div className="bag-light-2" style={{ zIndex: 99999 }}>
                                                                    <FontAwesomeIcon
                                                                        icon={showPassword.confirmPassword ? faEyeSlash : faEye}
                                                                        onClick={() => togglePasswordVisibility("confirmPassword")}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        {input.error && <p className="error-message" style={{ color: "red" }}>{input.error}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="save">
                            <button className="btn-save" onClick={handleSubmit}>Save</button>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Passwordpage;
